import { InformationCircleIcon } from '@heroicons/react/24/outline';

import { Text } from '@northladder/i18n';
import { TTextLocalized } from '@northladder/utilities';

interface ICameraFailedErrorProps {
  errorMsg: TTextLocalized;
  errorTitle: TTextLocalized;
  onRetry: () => void;
  retryCTAText: TTextLocalized;
}

/**
 * -----------------------------------------------------------------------------
 * Fallback UI shown when loading the camera fails.
 */
export function CameraFailedError({
  errorMsg,
  errorTitle,
  onRetry,
  retryCTAText,
}: ICameraFailedErrorProps) {
  return (
    <div className="base-grad flex h-full min-h-full w-full flex-col justify-center bg-red-50">
      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div className="shadow-xs bg-white px-4 py-8 sm:rounded-lg sm:px-10">
          <div className="mx-auto px-4 text-center sm:px-6 lg:px-8">
            <div className="mx-auto max-w-4xl flex-col items-center py-8">
              <InformationCircleIcon
                aria-hidden="true"
                className="mx-auto my-12 h-24 w-24 rounded-full  bg-red-50/50 p-4 text-red-600"
              />
              <h1 className="text-xl font-normal tracking-tight text-red-900 sm:text-xl">
                <Text text={errorTitle} />
              </h1>
              <p className="my-8 max-w-xl font-light text-red-900">
                <Text text={errorMsg} />
              </p>

              <button
                className="form-btn-secondary w-auto border bg-white text-base font-medium"
                onClick={onRetry}
                type="button"
              >
                <Text text={retryCTAText} />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
